export default [
    'square-right',
    'square-border',
    'add',
    'arrow-down',
    'arrow-up',
    'back',
    'audio',
    'benefits',
    'attachment',
    'building',
    'camera',
    'ballons',
    'badge',
    'calendar',
    'ace-frown',
    'arriving',
    'bus',
    'audio-mute',
    'chat',
    'close-window',
    'collapse',
    'call',
    'clean',
    'close',
    'balance',
    'customer-service',
    'cart',
    'danger',
    'conversation',
    'cash-card',
    'car',
    'card',
    'driver',
    'compass',
    'departure',
    'discount',
    'complain',
    'coin',
    'companion',
    'dislike',
    'delete',
    'email',
    'arrow',
    'edit',
    'face-happy',
    'expand',
    'flag',
    'elder',
    'fast',
    'female',
    'forward',
    'hints',
    'help',
    'heart',
    'dynamic-adjust',
    'drinks',
    'document',
    'face-smile',
    'hot',
    'error',
    'image',
    'like',
    'info',
    'home',
    'lock',
    'manual',
    'locate',
    'male',
    'invisible',
    'message',
    'location',
    'money',
    'keyboard',
    'more',
    'nav-drawer',
    'navigation',
    'my-account',
    'money-bag',
    'packet',
    'notification',
    'path',
    'more-services',
    'premium',
    'phone',
    'receipt',
    'reminder',
    'record',
    'qr',
    'remove',
    'maps',
    'game',
    'search',
    'seat',
    'secure-payment',
    'security',
    'scan',
    'selected',
    'report',
    'signal',
    'star',
    'swap',
    'ticket-bus',
    'shuttle',
    'settings',
    'time',
    'share',
    'shield',
    'question',
    'traffic-light',
    'travel-card',
    'trips',
    'steeering-wheel',
    'unlock',
    'user',
    'visible',
    'voice',
    'voucher',
    'trashcan',
    'timer',
    'voucher-discount',
    'wallet',
    'train'
];
